/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonStorageUploadFromJSON, InternalCommonStorageUploadToJSON, } from './InternalCommonStorageUpload';
/**
 * Check if a given object implements the InternalCommonUserPhoto interface.
 */
export function instanceOfInternalCommonUserPhoto(value) {
    if (!('thumb' in value) || value['thumb'] === undefined)
        return false;
    if (!('medium' in value) || value['medium'] === undefined)
        return false;
    if (!('large' in value) || value['large'] === undefined)
        return false;
    return true;
}
export function InternalCommonUserPhotoFromJSON(json) {
    return InternalCommonUserPhotoFromJSONTyped(json, false);
}
export function InternalCommonUserPhotoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'thumb': InternalCommonStorageUploadFromJSON(json['thumb']),
        'medium': InternalCommonStorageUploadFromJSON(json['medium']),
        'large': InternalCommonStorageUploadFromJSON(json['large']),
    };
}
export function InternalCommonUserPhotoToJSON(json) {
    return InternalCommonUserPhotoToJSONTyped(json, false);
}
export function InternalCommonUserPhotoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'thumb': InternalCommonStorageUploadToJSON(value['thumb']),
        'medium': InternalCommonStorageUploadToJSON(value['medium']),
        'large': InternalCommonStorageUploadToJSON(value['large']),
    };
}
